module.exports = __webpack_public_path__ + "media/images/three-dots-blue-b6de0dca7056c7bc1378dd11beeb8b10.svg";